import script from "./LineLoginButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LineLoginButton.vue?vue&type=script&setup=true&lang=ts"

import "./LineLoginButton.vue?vue&type=style&index=0&id=a185fd12&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a185fd12"]])

export default __exports__